import type { IsChunkLoadErrorParams } from '../types';

const CHUNK_LOAD_ERROR_PATTERNS = [
    'ChunkLoadError',
    'Failed to fetch dynamically imported module',
    'Importing a module script failed',
    'error loading dynamically imported module',
];

const isChunkLoadError = ({ error }: IsChunkLoadErrorParams): boolean =>
    CHUNK_LOAD_ERROR_PATTERNS.some(errorPattern => error.message.includes(errorPattern));

export default isChunkLoadError;
